import React from 'react';
import { Component, VBox } from "puzzle";
import MainGrid from "../../MainGrid/MainGrid";
import { ACTIONS_NAMES, INITIALIZE_USER } from "../Types";
import { PREFERENCES_DATA } from "../../Preferences/Types";

type PROPS = {
  initializeUserData: INITIALIZE_USER,
  preferencesData: PREFERENCES_DATA,
  actionsNames: ACTIONS_NAMES
};

class Favorites extends Component<PROPS, any> {
  downloadAlert() {
    console.log('Downloading...');
  };

  renderBody() {
    return (
      <VBox className={'tp-dashboard-view'} flex1 gap={4}>
        <MainGrid
          checkboxSelection={false}
          favoritesOnly={true}
          gridSectionAriaLabel={this.translate('SRL-section-table')}
          topSectionAriaLabel={this.translate('SRL-section-favorite-filters')}
          quickFiltersEnabled={true}
          title={this.translate('grid-title')}
          emptyGridConfig={{
            text: this.translate('gridEmptyLabel'),
            img: 'subs-grid'
          }}
          searchBarConfig={{
            pageTitle: this.translate('savedFilters'),
            initializeUserData: this.props.initializeUserData,
            filtersAsSearchBar: true
          }}
          {...this.props.preferencesData}
          actionsNames={this.props.actionsNames}
        />
      </VBox>
    );
  }
}

export default Favorites;
